import { Check } from "lucide-react";
import { useTranslate } from "ra-core";
import { cn } from "@/lib/utils";

/**
 * Round "done" button of a task, as in Todoist or iPhone Reminders: a check
 * shows on hover, the circle turns green once the task is done.
 */
export const TaskCheck = ({
  isDone,
  onToggle,
  disabled,
  className,
}: {
  isDone: boolean;
  onToggle: () => void;
  disabled?: boolean;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={isDone}
      aria-label={translate(
        isDone
          ? "resources.tasks.actions.reopen"
          : "resources.tasks.actions.mark_done",
      )}
      title={translate(
        isDone
          ? "resources.tasks.actions.reopen"
          : "resources.tasks.actions.mark_done",
      )}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      className={cn(
        "group/check size-5 shrink-0 rounded-full border-2 flex items-center justify-center transition-colors cursor-pointer",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50",
        isDone
          ? "bg-success border-success text-success-foreground"
          : "border-muted-foreground/40 text-success hover:border-success",
        className,
      )}
    >
      <Check
        strokeWidth={3}
        className={cn(
          "size-3 transition-opacity",
          isDone ? "opacity-100" : "opacity-0 group-hover/check:opacity-70",
        )}
      />
    </button>
  );
};
